import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  getAllPageSuccess,
  getAllSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
  getByIdSuccess,
  error,
  getAllPage,
} from './actions';

import { ServiceVeiculo } from '~/services/modulos/service_veiculo';
import { createSagaReutils, createAllTakeLastDefault } from '~/utils/reutils';
import ACTION from '../actionTypes';

const ACOES_DEFULT = createSagaReutils(
  `/veiculo`,
  ServiceVeiculo,
  getAllPage,
  getAllSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
  getByIdSuccess,
  error
);

function* listPageableSaga({ params }) {
  try {
    const list = yield call(ServiceVeiculo.getAllPageable, params);
    yield put(getAllPageSuccess(list));
  } catch (e) {
    yield put(error(e));
  }
}

export default all([
  ...createAllTakeLastDefault({ modulo: 'veiculo', ACOES: ACOES_DEFULT }),
  takeLatest(ACTION.VEICULO_GET_SEARCH_PAGE, listPageableSaga),
]);
